import { useState } from "react";
import { useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";
import {
    useCreateManagementNotesApiMutation,
    useDeleteManagementCompanyNoteByIdMutation,
    useGetManagementCompanyNotesByCompanyIdQuery
} from "../managementCompany";
import CommonNotesForm from "../../../../components/common/CommonNotesGrid/CommonNotesGrid";
import NotesUpdateOrAddModal from "../../../../components/common/CommonNotesGrid/NoteAddOrUpdateModal";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";


const ManagementCompanyNotesForm = () => {

    const { companyId } = useParams();
    const [deleteNotes, { isLoading }] = useDeleteManagementCompanyNoteByIdMutation();
    const [showAddModal, setShowshowAddModal] = useState(false);
    const [noteBody, setNoteBody] = useState<string>("");
    const [createNotesApi, createNotesApiResp] = useCreateManagementNotesApiMutation();

    const {
        data: notesData
    } = useGetManagementCompanyNotesByCompanyIdQuery(companyId || skipToken);


    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const noteDto = {
            message: noteBody,
            managementCompanyId: companyId

        };
        if (noteBody) {
            await handleRTKQuery(
                async () => {
                    return await createNotesApi({ id: companyId, obj: noteDto }).unwrap();
                },
                (isSuccess: boolean) => {
                    if (isSuccess) {
                        setShowshowAddModal(false);
                    }
                    setNoteBody("")
                }
            );
        }
    }

    const handleDelete = async (noteId: string) => {
        if (noteId) {
            await deleteNotes(noteId).unwrap();
        }
    };

    return (
        <>
            <CommonNotesForm
                data={notesData}
                title="Management Company Notes"
                type="MgmtCo"
                count={notesData?.length || 0}
                setShow={setShowshowAddModal}
                handleDelete={handleDelete}
                isLoading={isLoading}
                addPermissions={hasPermission(["MGTCOM-U"])}
                deletePermissions={hasPermission(["MGTCOM-D"])}
            />

            {showAddModal &&
                <NotesUpdateOrAddModal title={"Add Management Company  Note"}
                    show={showAddModal}
                    setShow={setShowshowAddModal}
                    relationalId={companyId}
                    type={"MgmtCo"}
                    length={notesData && notesData.length + 1}
                    btnName="Add" setNoteBody={setNoteBody} noteBody={noteBody}
                    handleSubmit={handleSubmit} isLoading={createNotesApiResp.isLoading}/>
            }
        </>
    );
};

export default ManagementCompanyNotesForm;
